// extracted by mini-css-extract-plugin
export default {"container":"Gold_container__dQVYk","content":"Gold_content__lPmdH","getInTouch":"Gold_getInTouch__VROPS"};